// extracted by mini-css-extract-plugin
module.exports = {"Container":"intro_Container__GxQ7J"};